import { createStore, ObservableMap } from "@stencil/store";
import { NOTIFICATION_TYPES, NotificationTypeId } from "../../../api/publicApi/notificationType";
import { SOFTWARE_TYPES, SoftwareType } from "../../../api/publicApi/software";
import { APPLICATION_IDS, ApplicationId } from "../../../api/applications";
import { ProductTechnologyType } from "../../../api/productTechnology";

const hideMachinesForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showErrorNumbersForNotificationTypes = [
    null,
    NOTIFICATION_TYPES.APPLICATION_ISSUES,
    NOTIFICATION_TYPES.MACHINE_STOP,
    NOTIFICATION_TYPES.FAULT_WITHOUT_STOP
];
const hideErrorNumbersForTechnologies = ["ELECTRONICS"];
const showSoftwareFieldsForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showSoftwareModulesForSoftwareTypes = [SOFTWARE_TYPES.TRUTOPS, SOFTWARE_TYPES.TRUTOPS_FAB, SOFTWARE_TYPES.TRUTOPS_BOOST];
const showApplicationIssuesForNotificationTypes = [NOTIFICATION_TYPES.APPLICATION_ISSUES];
const showApplicationIssuesForTechnologies = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];
const showWeldingApplicationFieldsForApplication = [APPLICATION_IDS.WELDING];

export interface FormStoreState {
    selectedNotificationType: NotificationTypeId | null;
    selectedSoftwareType: SoftwareType | null;
    selectedApplication: ApplicationId | null;
    formIsSubmitted: boolean;
    selectedMachineTechnology: ProductTechnologyType | null;
    showErrorNumbers: boolean;
    showApplications: boolean;
    showSoftwareModules: boolean;
    showMachines: boolean;
    showSoftwareFields: boolean;
    showWeldingApplicationFields: boolean;
}
export type FormStore = ObservableMap<FormStoreState>;
export const createFormStore = () => {
    const store = createStore<FormStoreState>({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        selectedApplication: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        showWeldingApplicationFields: false
    });

    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        store.state.showMachines = !hideMachinesForNotificationTypes.includes(selectedNotificationType as number);
        store.state.showSoftwareFields = showSoftwareFieldsForNotificationTypes.includes(selectedNotificationType as number);
        determineShowErrorNumbers();
        determineShowApplications();
    });

    store.onChange("selectedMachineTechnology", () => {
        determineShowErrorNumbers();
        determineShowApplications();
    });

    store.onChange("selectedApplication", (selectedApplication) => {
        store.state.showWeldingApplicationFields = showWeldingApplicationFieldsForApplication.includes(
            selectedApplication as ApplicationId
        );
    });

    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        store.state.showSoftwareModules = showSoftwareModulesForSoftwareTypes.includes(selectedSoftwareType as SoftwareType);
    });

    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            showApplicationIssuesForNotificationTypes.includes(selectedNotificationType as number) &&
            showApplicationIssuesForTechnologies.includes(selectedMachineTechnology as string);
    }

    function determineShowErrorNumbers() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showErrorNumbers =
            showErrorNumbersForNotificationTypes.includes(selectedNotificationType) &&
            !hideErrorNumbersForTechnologies.includes(selectedMachineTechnology as string);
    }

    return store;
};
